import fetch from '@/utils/fetch'

export const List = '/govsubsidy/setting/distributor/items'

// 保存国补地区
export function saveGovArea (data) {
  return fetch({
    url: '/govsubsidy/setting/area',
    method: 'post',
    data
  })
}

// 获取国补地区
export function getGovSettingArea (query) {
  return fetch({
    url: '/govsubsidy/setting/area',
    method: 'get',
    params: query
  })
}

// 设置门店商品补贴
export function setGovItems (data) {
  return fetch({
    url: '/govsubsidy/setting/distributor/items',
    method: 'post',
    data
  })
}

// 删除门店商品补贴
export function batchDelete (params) {
  return fetch({
    url: `/govsubsidy/setting/distributor/items`,
    method: 'delete',
    params
  })
}


// 删除国补地区
export function batchAearDelete (area) {
  return fetch({
    url: `/govsubsidy/setting/area`,
    method: 'delete',
    params: {
      area
    }
  })
}

// 获取门店国补商品列表
export function getGovItemList (query) {
  return fetch({
    url: '/govsubsidy/setting/distributor/itemlist',
    method: 'get',
    params: query
  })
}


// 更新门店国补使用状态
export function updategovSettingStatus (data) {
  return fetch({
	  url: '/govsubsidy/setting/openstatus',
	  method: 'put',
	  data
  })
}